import { DomesticAddress, ForeignAddress, Language as LanguageType } from '@shared/types'
import { ResolvedIntlConfig } from 'react-intl'

export enum PaymentFreeMonthsCount {
  Two = 2,
  One = 1,
  None = 0,
}

export enum CommonQueryParam {
  InitialLanguage = 'initialLang',
  SourceChannel = 'src',
  Flow = 'flow',
  Target = 'target',
  SkipBffStatusCheck = 'skipStatusCheck',
  Entry = 'entry',
}

export enum MaintenancePageQueryParams {
  DigiPlatformAppName = 'app',
}

export enum CreditLimitCategory {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

export const PHONE_COUNTRY_CODE = '+358'

export enum StorageKey {
  WizardState = 'wizard-state',
  Language = 'lang',
  Fingerprint = 'fp',
  AuthenticationRedirected = 'authenticationRedirected',
  SignStarted = 'signStarted',
  PaymentStarted = 'aoPaymentMachine-state',
  PaymentSubmit = 'adyen-checkout__checkout-attempt-id',
  PaymentRedirected = 'paymentRedirected',
  BackFromPayment = 'backFromPayment',
}

export enum CsatDifficultyLevel {
  VeryEasy = 'veryEasy',
  Easy = 'easy',
  Neutral = 'neutral',
  Difficult = 'difficult',
  VeryDifficult = 'veryDifficult',
}

export enum YesNo {
  Yes = 'yes',
  No = 'no',
}

export type NamedPerson = { firstName: string; lastName: string } | { firstNames: string; lastName: string }

export interface WithAddressInfo {
  hasDomesticAddress?: YesNo
  domesticAddress?: DomesticAddress
  foreignAddress?: ForeignAddress
}

export type ConditionalValues<T extends object> = {
  [Property in keyof T]-?: boolean
}

export type EventHandler = () => void

export type Messages = ResolvedIntlConfig['messages']

export type Translations = Record<LanguageType, Messages>
